


export const API_URL = process.env.REACT_APP_API_URL;
export const API_PORT = process.env.REACT_APP_PORT;

export const serverAddress = API_URL;
export const serverPORT = API_PORT;

export const fullServerAddress = API_URL + ':' + API_PORT